/**
 * Validates if a hostname is a proper URL.
 * Ensures it starts with 'https://' and contains a valid domain or IP address.
 *
 * @param {string} hostname - The input hostname
 * @returns {boolean} - Returns true if the hostname is valid
 */
export const isValidHostname = (hostname) => {
    const trimmed = hostname.trim();

    if (!trimmed.startsWith("https://")) {
        return false;
    }

    const withoutProtocol = trimmed.replace(/^https:\/\//, "");

    const domainOrIPRegex =
        /^(?:\d{1,3}\.){3}\d{1,3}$|^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    return domainOrIPRegex.test(withoutProtocol);
};

/**
 * Handles hostname validation and sets an error message if invalid.
 *
 * @param {string} hostname - The hostname input value
 * @param {Function} setError - Function to update the error state
 */
export const validateHostname = (hostname, setError) => {
    setError("");

    if (!isValidHostname(hostname)) {
        setError(
            "URL:en måste börja med 'https://' och innehålla en giltig domän.",
        );
    }
};
